import React, { useEffect, useState } from "react";
import { api, formatApiError } from "../lib/api";
import { Wrench, Loader2, CheckCircle2, Plus } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

const ALLOWED = ["admin", "operatore", "tecnico"];

export default function InterventoPianificaButton({ cid }) {
  const { user } = useAuth();
  const allowed = ALLOWED.includes(user?.role);
  const [status, setStatus] = useState(null); // {in_list, marked_planned}
  const [loading, setLoading] = useState(true);
  const [adding, setAdding] = useState(false);

  const load = async () => {
    try {
      const { data } = await api.get(`/interventi-da-pianificare/${cid}/status`);
      setStatus(data);
    } catch { /* */ } finally { setLoading(false); }
  };

  useEffect(() => { if (allowed) load(); else setLoading(false); /* eslint-disable-next-line */ }, [cid]);

  if (!allowed || loading) return null;

  const inActiveList = status?.in_list && !status?.marked_planned;

  const add = async () => {
    setAdding(true);
    try {
      await api.post(`/interventi-da-pianificare/${cid}/add`);
      setStatus({ in_list: true, marked_planned: false });
      toast.success("Cliente aggiunto agli Interventi da Pianificare");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setAdding(false);
    }
  };

  return (
    <div className="card-shell p-4 flex flex-wrap items-center justify-between gap-3" data-testid="intervento-pianifica-box">
      <div className="flex items-center gap-2">
        <div className="w-9 h-9 rounded-lg flex items-center justify-center" style={{ background: "var(--primary)15", color: "var(--primary)" }}>
          <Wrench className="w-4 h-4" />
        </div>
        <div>
          <div className="font-semibold text-sm" style={{ fontFamily: "Manrope" }}>Interventi da Pianificare</div>
          <div className="text-xs" style={{ color: "var(--text-muted)" }}>
            {inActiveList ? "Questo cliente è nella lista da pianificare." : "Aggiungi questo cliente alla lista per programmare un intervento."}
          </div>
        </div>
      </div>
      {inActiveList ? (
        <span className="inline-flex items-center gap-1.5 text-xs font-semibold px-3 py-1.5 rounded-full" style={{ background: "#D1FAE5", color: "#065F46" }} data-testid="intervento-in-lista-badge">
          <CheckCircle2 className="w-3.5 h-3.5" /> In lista
        </span>
      ) : (
        <button onClick={add} disabled={adding} className="btn-primary disabled:opacity-50" data-testid="intervento-add-pianifica">
          {adding ? <Loader2 className="w-4 h-4 animate-spin" /> : <Plus className="w-4 h-4" />} Aggiungi a Interventi da Pianificare
        </button>
      )}
    </div>
  );
}
